module.exports = __webpack_public_path__ + "static/media/moraine-35.f497dbde.jpg";